
import dayjs from "dayjs";
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { emptyToLine, splitThousands } from "@common/src/utils/common";
import { Table } from "@common/src/utils/decorator";
import { addCurrencyUnit, addCurrencySymbol } from "@common/src/utils/tools";
const finance = namespace("finance");
const base = namespace("base");
@Component({})
@Table("loadListData")
export default class PaymentOrder extends Vue {
  @finance.Action getPaymentList;
  @base.Action getDictionaryList;
  dayjs = dayjs;
  addCurrencyUnit = addCurrencyUnit;
  splitThousands = splitThousands;
  addCurrencySymbol = addCurrencySymbol;
  emptyToLine = emptyToLine;
  searchForm = {
    paymentNo: "",
    paidTimeFrom: "",
    paidTimeTo: "",
    paymentTimeFrom: "",
    paymentTimeTo: "",
    payeeName: "",
    paymentType: ""
  };
  paymentList: any[] = [];
  paymentTypeList: any[] = [];
  get searchList() {
    return [
      {
        label: this.$t("finance.payment-time"),
        type: "timerange",
        value: "",
        prop: "paidTime"
      },
      {
        label: this.$t("finance.creation-time"),
        type: "timerange",
        value: "",
        prop: "paymentTime"
      },
      {
        label: this.$t("finance.payment-no"),
        type: "input",
        value: "",
        prop: "paymentNo"
      },
      {
        label: this.$t("finance.payee"),
        type: "input",
        value: "",
        prop: "payeeName"
      },
      {
        label: this.$t("finance.type-payment"),
        type: "select",
        selectList: this.paymentTypeList,
        value: "",
        prop: "paymentType"
      }
    ];
  }

  created() {
    this.init();
  }
  handleSearch(data) {
    this.mix_pageNum = 1;
    data.forEach(item => {
      if (item.prop) {
        if (item.prop === "paymentTime" || item.prop === "paidTime") {
          this.searchForm[item.prop + "From"] = item.value ? item.value[0] : "";
          this.searchForm[item.prop + "To"] = item.value ? item.value[1] : "";
        } else {
          this.searchForm[item.prop] = item.value;
        }
      }
    });
    this.loadListData();
  }
  totalPaidAmount: string = "";
  @Table.LoadDataMethod()
  loadListData() {
    return this.getPaymentList({
      orderItems: this.mix_sortParams,
      ...this.searchForm,
      pageSize: this.mix_pageSize,
      pageNum: this.mix_pageNum
    }).then(data => {
      this.totalPaidAmount = this.$safeValue(data, "data.totalPaidAmount");
      this.paymentList = this.$safeValue(data, "data.list");
      return data;
    });
  }

  handleLinkView(row) {
    window.open(this.$router.resolve(`/finance/payment-order-view/${row.paymentNo}`).href);
  }
  init() {
    this.loadListData();
    this.getDictionaryList("payment_type").then(data => {
      this.paymentTypeList = data;
    });
  }
}
